import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    clientName: {
      validations: []
    },
    email: {
      validations: [
        { type: 'required', message: 'This field is required.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'This field is required.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    accountextra1: {
      validations: []
    },
    category: {
      validations: []
    },
    accountextra2: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    accountextra5: {
      validations: []
    },
    accountextra6: {
      validations: []
    },
    siteName: {
      validations: []
    },
    reference: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    accountextra3: {
      validations: []
    },
    accountextra7: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name *',
            mapping: 'firstName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name *',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company',
            mapping: 'clientName'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email *',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone *',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'What Type of event are you planning?',
            options: [
              { label: 'Wedding Reception', value: 'Wedding Reception' },
              { label: 'Corporate Event', value: 'Corporate Event' },
              { label: 'Holiday Party', value: 'Holiday Party' },
              { label: 'Fundraiser', value: 'Fundraiser' },
              { label: 'Social Event', value: 'Social Event' },
              { label: 'Fundraiser', value: 'Fundraiser' },
              { label: 'Prom', value: 'Prom' },
              { label: 'Other', value: 'Other' }
            ],
            mapping: 'accountextra1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Category',
            options: [
              { label: 'Social', value: 'Social' },
              { label: 'Corporate', value: 'Corporate' }
            ],
            mapping: 'category'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Date of Event',
            mapping: 'accountextra2'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Start Time',
            options: [
              { label: '7:30 AM', value: '07:30:00' },
              { label: '8:00 AM', value: '08:00:00' },
              { label: '8:30 AM', value: '08:30:00' },
              { label: '9:00 AM', value: '09:00:00' },
              { label: '9:30 AM', value: '09:30:00' },
              { label: '10:00 AM', value: '10:00:00' },
              { label: '10:30 AM', value: '10:30:00' },
              { label: '11:00 AM', value: '11:00:00' },
              { label: '11:30 AM', value: '11:30:00' },
              { label: '12:00 PM', value: '12:00:00' },
              { label: '12:30 PM', value: '12:30:00' },
              { label: '1:00 PM', value: '13:00:00' },
              { label: '1:30 PM', value: '13:30:00' },
              { label: '2:00 PM', value: '14:00:00' },
              { label: '2:30 PM', value: '14:30:00' },
              { label: '3:00 PM', value: '15:00:00' },
              { label: '3:30 PM', value: '15:30:00' },
              { label: '4:00 PM', value: '16:00:00' },
              { label: '4:30 PM', value: '16:30:00' },
              { label: '5:00 PM', value: '17:00:00' },
              { label: '5:30 PM', value: '17:30:00' },
              { label: '6:00 PM', value: '18:00:00' },
              { label: '6:30 PM', value: '18:30:00' },
              { label: '7:00 PM', value: '19:00:00' },
              { label: '7:30 PM', value: '19:30:00' },
              { label: '8:00 PM', value: '20:00:00' },
              { label: '8:30 PM', value: '20:30:00' },
              { label: '9:00 PM', value: '21:00:00' },
              { label: '9:30 PM', value: '21:30:00' },
              { label: '10:00 PM', value: '22:00:00' },
              { label: '10:30 PM', value: '22:30:00' },
              { label: '11:00 PM', value: '23:00:00' },
              { label: '11:30 PM', value: '23:30:00' },
              { label: '12:00 AM (next day)', value: '00:00:00' },
              { label: '12:30 AM (next day)', value: '00:30:00' },
              { label: '1:00 AM (next day)', value: '01:00:00' },
              { label: '1:30 AM (next day)', value: '01:30:00' },
              { label: '2:00 AM (next day)', value: '02:00:00' },
              { label: '2:30 AM (next day)', value: '02:30:00' }
            ],
            mapping: 'accountextra5'
          }
        ]
      },

      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Is this date flexible?',
            options: [
              { label: 'Yes', value: 'Yes' },
              { label: 'No', value: 'No' },
            ],
            mapping: 'accountextra6'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Offsite Catering',
            options: [
              { label: 'Yes', value: 'Yes' },
              { label: 'No', value: 'No' },
            ],
            mapping: 'accountextra7'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How did you hear about us? *',
            options: [
              { label: 'Been to Depot Before', value: 'Been to Depot Before' },
              { label: 'BNI - Referral', value: 'BNI - Referral' },
              { label: 'Brides of North Texas', value: 'Brides of North Texas' },
              { label: 'Chamber of Commerce', value: 'Chamber of Commerce' },
              { label: 'Eventective', value: 'Eventective' },
              { label: 'Facebook', value: 'Facebook' },
              { label: 'From a Past Client', value: 'From a Past Client' },
              { label: 'Google', value: 'Google' },
              { label: 'Here Comes the Guide', value: 'Here Comes the Guide' },
              { label: 'I am a Past Client', value: 'I am a Past Client' },
              { label: 'Instagram', value: 'Instagram' },
              { label: 'Other', value: 'Other' },
              { label: 'Planner', value: 'Planner' },
              { label: 'Referral - Ashlee Johnson', value: 'Referral - Ashlee Johnson' },
              { label: 'Referral - Cindy Vazquez', value: 'Referral - Cindy Vazquez' },
              { label: 'Referral - Other', value: 'Referral - Other' },
              { label: 'Referral - Wedding/Event Planner', value: 'Referral - Wedding/Event Planner' },
              { label: 'Saw our Billboard', value: 'Saw our Billboard' },
              { label: 'The Knot', value: 'The Knot' },
              { label: 'Vendor', value: 'Vendor' },
              { label: 'Visit Fort Worth', value: 'Visit Fort Worth' },
              { label: 'Wedding Wire', value: 'Wedding Wire' },
              { label: 'Word of Mouth', value: 'Word of Mouth' },
              { label: 'Referral - BNI', value: 'Referral - BNI' },
            ],
            mapping: 'reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Planned Guests',
            mapping: 'accountextra3'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Your questions or comments:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit Form'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Ashton Depot Catering Contact Us Form',
    formId: '541',
    clientKey: 'EE76B59F-1D41-467F-AF42-735C177AA7D9',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
